import React, { useState, useEffect } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  Block,
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  Icon,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  PaginationComponent,
  RSelect,
  Col,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import { api } from "../../../utils/api";
import { toast } from "react-toastify";
import { Badge, Spinner, Input, Label } from "reactstrap";
import { PreviewCard } from "../../../components/Component";
import classnames from "classnames";

// Fonction pour traduire les noms de permissions en noms compréhensibles
const translatePermissionName = (permissionName) => {
  const translations = {
    // Activity Logs
    'activity-logs.view': 'Voir l\'historique',
    'activity-logs.details': 'Voir les détails de l\'historique',
    'Activity Logs - View': 'Voir l\'historique',
    'Activity Logs - Details': 'Voir les détails de l\'historique',
    
    // Card of Month
    'card-of-month.view': 'Voir la carte du mois',
    'card-of-month.select': 'Sélectionner la carte du mois',
    'card-of-month.employee': 'Gérer l\'employé du mois',
    'Carte du mois - Voir': 'Voir la carte du mois',
    'Carte du mois - Sélectionner': 'Sélectionner la carte du mois',
    'Carte du mois - Employé': 'Gérer l\'employé du mois',
    
    // Observations
    'observations.view': 'Voir les observations',
    'observations.create': 'Créer des observations',
    'observations.edit': 'Modifier les observations',
    'observations.update': 'Modifier les observations',
    'observations.delete': 'Supprimer les observations',
    'observations.approve': 'Approuver les observations',
    'observations.reject': 'Rejeter les observations',
    'Observations - Voir': 'Voir les observations',
    'Observations - Créer': 'Créer des observations',
    'Observations - Modifier': 'Modifier les observations',
    'Observations - Supprimer': 'Supprimer les observations',
    'Observations - Approuver': 'Approuver les observations',
    'Observations - Rejeter': 'Rejeter les observations',
    
    // Sites
    'sites.view': 'Voir les sites',
    'sites.create': 'Créer des sites',
    'sites.edit': 'Modifier les sites',
    'sites.update': 'Modifier les sites',
    'sites.delete': 'Supprimer les sites',
    'Sites - Voir': 'Voir les sites',
    'Sites - Créer': 'Créer des sites',
    'Sites - Modifier': 'Modifier les sites',
    'Sites - Supprimer': 'Supprimer les sites',
    
    // Users
    'users.view': 'Voir les utilisateurs',
    'users.create': 'Créer des utilisateurs',
    'users.edit': 'Modifier les utilisateurs',
    'users.update': 'Modifier les utilisateurs',
    'users.delete': 'Supprimer les utilisateurs',
    'users.activate': 'Activer les utilisateurs',
    'users.deactivate': 'Désactiver les utilisateurs',
    'Utilisateurs - Voir': 'Voir les utilisateurs',
    'Utilisateurs - Créer': 'Créer des utilisateurs',
    'Utilisateurs - Modifier': 'Modifier les utilisateurs',
    'Utilisateurs - Supprimer': 'Supprimer les utilisateurs',
    'Utilisateurs - Activer': 'Activer les utilisateurs',
    'Utilisateurs - Désactiver': 'Désactiver les utilisateurs',
    
    // Roles
    'roles.view': 'Voir les rôles',
    'roles.create': 'Créer des rôles',
    'roles.edit': 'Modifier les rôles',
    'roles.update': 'Modifier les rôles',
    'roles.delete': 'Supprimer les rôles',
    'roles.assign': 'Assigner des rôles',
    'permissions.view': 'Voir les permissions',
    'Rôles - Voir': 'Voir les rôles',
    'Rôles - Créer': 'Créer des rôles',
    'Rôles - Modifier': 'Modifier les rôles',
    'Rôles - Supprimer': 'Supprimer les rôles',
    'Rôles - Assigner': 'Assigner des rôles',
    'Permissions - Voir': 'Voir les permissions',
    
    // Site Assignment
    'site-assignment.view': 'Voir les attributions de sites',
    'site-assignment.assign': 'Assigner des sites',
    'site-assignment.remove': 'Retirer des sites',
    'Attribution Sites - Voir': 'Voir les attributions de sites',
    'Attribution Sites - Assigner': 'Assigner des sites',
    'Attribution Sites - Retirer': 'Retirer des sites',
    
    // Dashboard
    'dashboard.view': 'Voir le tableau de bord',
    'dashboard.hse': 'Voir le tableau de bord HSE',
    'dashboard.management': 'Voir le tableau de bord Direction',
    'Tableau de bord - Voir': 'Voir le tableau de bord',
    'Tableau de bord - HSE': 'Voir le tableau de bord HSE',
    'Tableau de bord - Management': 'Voir le tableau de bord Direction',
    
    // Workflow
    'workflow.view': 'Voir le workflow',
    'workflow.edit': 'Modifier le workflow',
    'workflow.update': 'Modifier le workflow',
    'workflow.history': 'Voir l\'historique du workflow',
    'Workflow - Voir': 'Voir le workflow',
    'Workflow - Modifier': 'Modifier le workflow',
    'Workflow - Historique': 'Voir l\'historique du workflow',
    
    // Reports
    'reports.view': 'Voir les rapports',
    'reports.create': 'Créer des rapports',
    'reports.monthly': 'Voir les rapports mensuels',
    'reports.sites': 'Voir les rapports par site',
    'reports.custom': 'Voir les rapports personnalisés',
    
    // Analytics
    'analytics.view': 'Voir les analyses',
    'analytics.hse': 'Voir les analyses HSE',
    
    // Notifications
    'notifications.view': 'Voir les notifications',
    'notifications.send': 'Envoyer des notifications',
    
    // Risk Mapping
    'risk-mapping.view': 'Voir la cartographie des risques',
    'risk-mapping.create': 'Créer des risques',
    'risk-mapping.edit': 'Modifier les risques',
    'risk-mapping.delete': 'Supprimer les risques',
    
    // Gamification
    'gamification.view': 'Voir la gamification',
    'gamification.leaderboard': 'Voir les classements',
    'gamification.badges': 'Gérer les badges',
    'gamification.points': 'Gérer les points',
    
    // Compliance
    'compliance.view': 'Voir la conformité',
    'compliance.audit-trail': 'Voir l\'audit trail',
    'compliance.traceability': 'Voir la traçabilité',
    'compliance.audit-reports': 'Voir les rapports d\'audit',
    'compliance.iso': 'Voir la conformité ISO',
  };
  
  // Retourner la traduction si elle existe, sinon retourner le nom original
  return translations[permissionName] || permissionName;
};

// Traduction des noms de groupes de permissions en français
const translateGroupName = (groupName) => {
  if (!groupName) return groupName;
  const translations = {
    'Observations': 'Observations',
    'Sites': 'Sites',
    'Utilisateurs': 'Utilisateurs',
    'Rôles': 'Rôles',
    'Permissions': 'Permissions',
    'Attribution Sites': 'Attribution par site',
    'Tableau de bord': 'Tableau de bord',
    'Workflow': 'Workflow',
    'Carte du mois': 'Carte du mois',
    'Configuration scoring': 'Configuration scoring',
    'Historique': 'Historique des actions',
    'Système': 'Système',
    'Activity Logs': 'Historique des actions',
    'activity-logs': 'Historique des actions',
    'Card of Month': 'Carte du mois',
    'card-of-month': 'Carte du mois',
    'observations': 'Observations',
    'sites': 'Sites',
    'users': 'Utilisateurs',
    'roles': 'Rôles',
    'permissions': 'Permissions',
    'site-assignment': 'Attribution par site',
    'dashboard': 'Tableau de bord',
    'workflow': 'Workflow',
    'reports': 'Rapports',
    'analytics': 'Analyses',
    'notifications': 'Notifications',
    'risk-mapping': 'Cartographie des risques',
    'gamification': 'Gamification',
    'compliance': 'Conformité',
  };
  return translations[groupName] || groupName;
};

const RolePermissionManagement = () => {
  const [activeTab, setActiveTab] = useState("roles");
  const [sm, updateSm] = useState(false);
  const [modal, setModal] = useState({ role: false, view: false });
  const [editId, setEditId] = useState(null);
  const [viewItem, setViewItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    permission_ids: [],
  });

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    if (activeTab === "roles") {
      loadRoles();
    } else {
      loadPermissions();
    }
  }, [activeTab, currentPage, searchText]);

  useEffect(() => {
    // Charger toutes les permissions pour les formulaires
    loadAllPermissions();
  }, []);

  const loadRoles = async () => {
    setLoading(true);
    try {
      const params = { page: currentPage, per_page: itemPerPage };
      if (searchText) params.search = searchText;
      const response = await api.getRoles(params);
      if (response.data) {
        setRoles(response.data);
        setTotalItems(response.total || 0);
      } else {
        setRoles(response);
        setTotalItems(response.length || 0);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des rôles");
      setRoles([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };

  const loadPermissions = async () => {
    setLoading(true);
    try {
      const params = { page: currentPage, per_page: itemPerPage };
      if (searchText) params.search = searchText;
      const response = await api.getPermissions(params);
      if (response.data) {
        setPermissions(response.data);
        setTotalItems(response.total || 0);
      } else {
        setPermissions(response);
        setTotalItems(response.length || 0);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des permissions");
      setPermissions([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };


  const loadAllPermissions = async () => {
    try {
      const response = await api.getPermissions({ per_page: 1000 });
      setAllPermissions(response.data || response || []);
    } catch (error) {
      // Ignorer l'erreur
    }
  };

  const resetForm = () => {
    setFormData({ name: "", permission_ids: [] });
    setEditId(null);
  };

  const onRoleSubmit = async (sData) => {
    try {
      const data = { ...formData, ...sData };
      if (editId) {
        await api.updateRole(editId, data);
        toast.success("Rôle mis à jour avec succès");
      } else {
        await api.createRole(data);
        toast.success("Rôle créé avec succès");
      }
      loadRoles();
      resetForm();
      setModal({ role: false });
    } catch (error) {
      toast.error(error.message || "Erreur lors de l'opération");
    }
  };

  const onEditClick = async (id, type) => {
    if (type === "permission") {
      // Les permissions ne peuvent pas être modifiées
      return;
    }
    try {
      const item = await api.getRole(id);
      setFormData({
        name: item.name || "",
        permission_ids: item.permissions ? item.permissions.map((p) => p.id) : [],
      });
      setEditId(id);
      setModal({ role: true });
    } catch (error) {
      toast.error("Erreur lors du chargement");
    }
  };

  const onViewClick = async (id, type) => {
    try {
      const item = type === "role" ? await api.getRole(id) : await api.getPermission(id);
      setViewItem(item);
      setModal({ view: true });
    } catch (error) {
      toast.error("Erreur lors du chargement");
    }
  };

  const onDeleteClick = (id, type) => {
    if (type === "permission") {
      // Les permissions ne peuvent pas être supprimées
      return;
    }
    const role = roles.find((r) => r.id === id);
    if (role) {
      setRoleToDelete(role);
      setDeleteModal(true);
    }
  };

  const onDeleteConfirm = async () => {
    if (!roleToDelete) return;
    try {
      await api.deleteRole(roleToDelete.id);
      toast.success("Rôle supprimé avec succès");
      setDeleteModal(false);
      setRoleToDelete(null);
      loadRoles();
    } catch (error) {
      toast.error(error.message || "Erreur lors de la suppression");
    }
  };

  const onDeleteCancel = () => {
    setDeleteModal(false);
    setRoleToDelete(null);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Gestion des rôles et permissions" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Gestion des rôles et permissions</BlockTitle>
              <BlockDes className="text-soft">Gérez les rôles et permissions de votre système</BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    {activeTab === "roles" && (
                      <li className="nk-block-tools-opt">
                        <Button color="primary" onClick={() => setModal({ role: true })}>
                          <Icon name="plus"></Icon>
                          <span>Nouveau rôle</span>
                        </Button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Nav tabs className="nav-tabs-s2">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "roles" })}
                onClick={() => {
                  setActiveTab("roles");
                  setCurrentPage(1);
                }}
              >
                <Icon name="user-alt"></Icon>
                <span>Rôles</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "permissions" })}
                onClick={() => {
                  setActiveTab("permissions");
                  setCurrentPage(1);
                }}
              >
                <Icon name="shield-check"></Icon>
                <span>Permissions</span>
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="mt-4">
            <TabPane tabId="roles">
              <BlockHead>
                <BlockBetween>
                  <BlockHeadContent>
                    <ul className="nk-block-tools g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-left">
                            <Icon name="search"></Icon>
                          </div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Rechercher un rôle..."
                            value={searchText}
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              setCurrentPage(1);
                            }}
                            style={{ minWidth: "250px" }}
                          />
                        </div>
                      </li>
                    </ul>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>

              <DataTable className="card-stretch">
                <DataTableBody>
                  <DataTableHead className="nk-tb-item nk-tb-head">
                    <DataTableRow>
                      <span className="sub-text">Nom</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="sub-text">Permissions</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="sub-text">Utilisateurs</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools text-end"></DataTableRow>
                  </DataTableHead>
                  {loading ? (
                    <DataTableItem>
                      <DataTableRow>
                        <DataTableItem colSpan={4} className="text-center">
                          <Spinner color="primary" />
                        </DataTableItem>
                      </DataTableRow>
                    </DataTableItem>
                  ) : roles.length === 0 ? (
                    <DataTableItem>
                      <DataTableRow>
                        <DataTableItem colSpan={4} className="text-center">
                          <PreviewCard>
                            <div className="text-center py-4">
                              <span className="text-soft">Aucun rôle trouvé</span>
                            </div>
                          </PreviewCard>
                        </DataTableItem>
                      </DataTableRow>
                    </DataTableItem>
                  ) : (
                    roles.map((role) => (
                      <DataTableItem key={role.id}>
                        <DataTableRow>
                          <span className="tb-lead">{role.name}</span>
                        </DataTableRow>
                        <DataTableRow>
                          <Badge color="info">{role.permissions_count || 0} permission(s)</Badge>
                        </DataTableRow>
                        <DataTableRow>
                          <Badge color="secondary">{role.users_count || 0} utilisateur(s)</Badge>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools">
                          <ul className="nk-tb-actions gx-1">
                            <li>
                              <button
                                className="btn btn-trigger btn-icon"
                                onClick={() => onViewClick(role.id, "role")}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Voir"
                              >
                                <Icon name="eye"></Icon>
                              </button>
                            </li>
                            <li>
                              <button
                                className="btn btn-trigger btn-icon"
                                onClick={() => onEditClick(role.id, "role")}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Modifier"
                              >
                                <Icon name="edit"></Icon>
                              </button>
                            </li>
                            <li className="nk-tb-action-hidden">
                              <button
                                className="btn btn-trigger btn-icon text-danger"
                                onClick={() => onDeleteClick(role.id, "role")}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Supprimer"
                              >
                                <Icon name="trash"></Icon>
                              </button>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    ))
                  )}
                </DataTableBody>
                <div className="card-inner">
                  {totalItems > 0 && (
                    <PaginationComponent
                      itemPerPage={itemPerPage}
                      totalItems={totalItems}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  )}
                </div>
              </DataTable>
            </TabPane>

            <TabPane tabId="permissions">
              <BlockHead>
                <BlockBetween>
                  <BlockHeadContent>
                    <ul className="nk-block-tools g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-left">
                            <Icon name="search"></Icon>
                          </div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Rechercher une permission..."
                            value={searchText}
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              setCurrentPage(1);
                            }}
                            style={{ minWidth: "250px" }}
                          />
                        </div>
                      </li>
                    </ul>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>

              <DataTable className="card-stretch">
                <DataTableBody>
                  <DataTableHead className="nk-tb-item nk-tb-head">
                    <DataTableRow>
                      <span className="sub-text">Nom</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="sub-text">Groupe</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="sub-text">Rôles</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools text-end"></DataTableRow>
                  </DataTableHead>
                  {loading ? (
                    <DataTableItem>
                      <DataTableRow>
                        <DataTableItem colSpan={4} className="text-center">
                          <Spinner color="primary" />
                        </DataTableItem>
                      </DataTableRow>
                    </DataTableItem>
                  ) : permissions.length === 0 ? (
                    <DataTableItem>
                      <DataTableRow>
                        <DataTableItem colSpan={4} className="text-center">
                          <PreviewCard>
                            <div className="text-center py-4">
                              <span className="text-soft">Aucune permission trouvée</span>
                            </div>
                          </PreviewCard>
                        </DataTableItem>
                      </DataTableRow>
                    </DataTableItem>
                  ) : (
                    permissions.map((permission) => (
                      <DataTableItem key={permission.id}>
                        <DataTableRow>
                          <span className="tb-lead">{translatePermissionName(permission.name)}</span>
                        </DataTableRow>
                        <DataTableRow>
                          {permission.group ? (
                            <Badge color="primary">{translateGroupName(permission.group)}</Badge>
                          ) : (
                            <span className="text-soft">-</span>
                          )}
                        </DataTableRow>
                        <DataTableRow>
                          <Badge color="info">{permission.roles_count || 0} rôle(s)</Badge>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools"></DataTableRow>
                      </DataTableItem>
                    ))
                  )}
                </DataTableBody>
                <div className="card-inner">
                  {totalItems > 0 && (
                    <PaginationComponent
                      itemPerPage={itemPerPage}
                      totalItems={totalItems}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  )}
                </div>
              </DataTable>
            </TabPane>
          </TabContent>
        </Block>

        {/* Modal Role */}
        <Modal isOpen={modal.role} toggle={() => { setModal({ role: false }); resetForm(); }} className="modal-dialog-centered" size="lg">
          <div className="modal-header">
            <h5 className="modal-title">{editId ? "Modifier le rôle" : "Nouveau rôle"}</h5>
            <button className="close" onClick={() => { setModal({ role: false }); resetForm(); }}>
              <Icon name="cross"></Icon>
            </button>
          </div>
          <ModalBody>
            <Form className="is-alter" onSubmit={handleSubmit(onRoleSubmit)}>
              <div className="form-group">
                <label className="form-label">Nom du rôle *</label>
                <input
                  type="text"
                  name="name"
                  defaultValue={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  ref={register({ required: "Ce champ est requis" })}
                />
                {errors.name && (
                  <div className="invalid-feedback d-block">{errors.name.message}</div>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">Permissions</label>
                <RSelect
                  isMulti
                  options={allPermissions.map((p) => ({ value: p.id, label: translatePermissionName(p.name) }))}
                  value={formData.permission_ids.map((id) => {
                    const perm = allPermissions.find((p) => p.id === id);
                    return perm ? { value: perm.id, label: translatePermissionName(perm.name) } : null;
                  }).filter(Boolean)}
                  onChange={(selected) => {
                    setFormData({
                      ...formData,
                      permission_ids: selected ? selected.map((opt) => opt.value) : [],
                    });
                  }}
                  placeholder="Sélectionner les permissions"
                />
              </div>
              <div className="form-group text-end">
                <Button color="light" onClick={() => { setModal({ role: false }); resetForm(); }} className="me-2">
                  Annuler
                </Button>
                <Button color="primary" type="submit">
                  {editId ? "Modifier" : "Créer"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        {/* Modal Voir Rôle */}
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          {viewItem && (
            <>
              <div className="modal-header border-bottom">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div>
                    <h5 className="modal-title mb-1">{viewItem.name}</h5>
                    <div className="d-flex mt-2 gap-2">
                      <Badge color="info">{viewItem.permissions_count || 0} permission(s)</Badge>
                      <Badge color="secondary">{viewItem.users_count || 0} utilisateur(s)</Badge>
                    </div>
                  </div>
                  <button className="close" onClick={() => setModal({ view: false })}>
                    <Icon name="cross"></Icon>
                  </button>
                </div>
              </div>
              <ModalBody className="p-4">
                <div className="row g-4">
                  <Col md="12">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="info" className="me-2"></Icon>
                          Informations générales
                        </h6>
                        <div className="row">
                          <div className="col-md-6">
                            <p className="mb-2"><strong>Nom du rôle:</strong></p>
                            <p>{viewItem.name}</p>
                          </div>
                          <div className="col-md-6">
                            <p className="mb-2"><strong>Guard:</strong></p>
                            <p>{viewItem.guard_name || 'web'}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  {viewItem.permissions && viewItem.permissions.length > 0 && (
                    <Col md="12">
                      <div className="card border-0 bg-light">
                        <div className="card-body p-4">
                          <h6 className="title mb-3">
                            <Icon name="shield-check" className="me-2"></Icon>
                            Permissions ({viewItem.permissions.length})
                          </h6>
                          <div className="d-flex flex-wrap gap-2">
                            {viewItem.permissions.map((permission) => (
                              <Badge key={permission.id} color="primary">
                                {translatePermissionName(permission.name)}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col md="6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="calendar" className="me-2"></Icon>
                          Date de création
                        </h6>
                        <p className="mb-0">
                          {viewItem.created_at
                            ? new Date(viewItem.created_at).toLocaleString('fr-FR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            : '-'}
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="calendar-alt" className="me-2"></Icon>
                          Dernière modification
                        </h6>
                        <p className="mb-0">
                          {viewItem.updated_at
                            ? new Date(viewItem.updated_at).toLocaleString('fr-FR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            : '-'}
                        </p>
                      </div>
                    </div>
                  </Col>
                </div>

                <div className="mt-4 text-end">
                  <Button color="light" onClick={() => setModal({ view: false })}>
                    Fermer
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </Modal>

        {/* Modal de confirmation de suppression */}
        <Modal isOpen={deleteModal} toggle={onDeleteCancel} className="modal-dialog-centered">
          <div className="modal-header">
            <h5 className="modal-title">Confirmer la suppression</h5>
            <button className="close" onClick={onDeleteCancel}>
              <Icon name="cross"></Icon>
            </button>
          </div>
          <ModalBody>
            <p>
              Êtes-vous sûr de vouloir supprimer le rôle <strong>"{roleToDelete?.name}"</strong> ?
            </p>
            <p className="text-soft small">Cette action est irréversible.</p>
            {roleToDelete && roleToDelete.users_count > 0 && (
              <div className="alert alert-warning mt-3">
                <Icon name="alert-circle" className="me-2"></Icon>
                <strong>Attention:</strong> Ce rôle est assigné à {roleToDelete.users_count} utilisateur(s).
                La suppression de ce rôle retirera l'accès à ces utilisateurs.
              </div>
            )}
            <div className="form-group text-end mt-4">
              <Button color="light" onClick={onDeleteCancel} className="me-2">
                Annuler
              </Button>
              <Button color="danger" onClick={onDeleteConfirm}>
                Supprimer
              </Button>
            </div>
          </ModalBody>
        </Modal>

      </Content>
    </React.Fragment>
  );
};

export default RolePermissionManagement;

